// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnterpriseCoordinatorPayorServiceModelsPayorBenefitModel {
    static getAttributeTypeMap() {
        return EnterpriseCoordinatorPayorServiceModelsPayorBenefitModel.attributeTypeMap;
    }
}
EnterpriseCoordinatorPayorServiceModelsPayorBenefitModel.discriminator = undefined;
EnterpriseCoordinatorPayorServiceModelsPayorBenefitModel.additionalProperties = false;
EnterpriseCoordinatorPayorServiceModelsPayorBenefitModel.attributeTypeMap = [
    {
        "name": "dateOfBirth",
        "baseName": "dateOfBirth",
        "type": "Date"
    },
    {
        "name": "policyHolderFirstName",
        "baseName": "policyHolderFirstName",
        "type": "string"
    },
    {
        "name": "policyHolderLastName",
        "baseName": "policyHolderLastName",
        "type": "string"
    },
    {
        "name": "relationshipToPatient",
        "baseName": "relationshipToPatient",
        "type": "RoleType"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "string"
    },
    {
        "name": "groupNumber",
        "baseName": "groupNumber",
        "type": "string"
    },
    {
        "name": "policyNumber",
        "baseName": "policyNumber",
        "type": "string"
    },
    {
        "name": "personCode",
        "baseName": "personCode",
        "type": "string"
    },
    {
        "name": "planType",
        "baseName": "planType",
        "type": "PlanType"
    },
    {
        "name": "planEffectiveDate",
        "baseName": "planEffectiveDate",
        "type": "Date"
    },
    {
        "name": "planExpirationDate",
        "baseName": "planExpirationDate",
        "type": "Date"
    },
    {
        "name": "planTerminationDate",
        "baseName": "planTerminationDate",
        "type": "Date"
    },
    {
        "name": "policyName",
        "baseName": "policyName",
        "type": "string"
    },
    {
        "name": "employer",
        "baseName": "employer",
        "type": "string"
    },
    {
        "name": "bin",
        "baseName": "bin",
        "type": "string"
    },
    {
        "name": "pcn",
        "baseName": "pcn",
        "type": "string"
    },
];
//# sourceMappingURL=enterpriseCoordinatorPayorServiceModelsPayorBenefitModel.js.map